export default {
  label: 'Replied',
  items: {
    placeholder: 'All',
    replied: 'Only Replied',
    unanswered: 'Only Unreplied',
  },
};
